export const SECRET_OTP_KEY = process.env.REACT_APP_SECRET_OTP_KEY || '';

export const apiUrls = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  SEND_OTP_URL: 'api/v2/login/sendOtp/',
  VERIFY_OTP_URL: 'api/v2/login/verifyOtp/',
  CANCEL_MEMBERSHIP_OF_USER_URL: 'api/v1/cancel-membership'
};
